import { useQuery } from 'react-query';
import { layoffService } from '_services';
import { retryServerErrors, useLayoffMutation } from '../useLayoff';

export const reviewKeys = {
  detail: (hash) => ['layoffs', 'review', hash],
  preview: (hash, draft) => ['layoffs', 'review', 'preview', hash, draft],
  lists: ['layoffs', 'notification-lists'],
};

export const useReview = (hash) =>
  useQuery(reviewKeys.detail(hash), () => layoffService.getReview(hash), {
    retry: retryServerErrors,
  });

export const useReviewPreview = (hash, draft, enabled = true) =>
  useQuery(
    reviewKeys.preview(hash, draft),
    () => layoffService.getReviewPreview({ hash, draft }),
    { enabled, keepPreviousData: true, staleTime: 5 * 60 * 1000 },
  );

export const useSaveReview = (options) =>
  useLayoffMutation(layoffService.saveReview, {
    showFieldErrors: true,
    ...options,
  });

export const useFinalizeLayoff = (options) =>
  useLayoffMutation(layoffService.finalizeLayoff, {
    showFieldErrors: true,
    ...options,
  });

export const useNotificationLists = () =>
  useQuery(reviewKeys.lists, layoffService.getNotificationLists);

export const useSaveNotificationLists = (options) =>
  useLayoffMutation(layoffService.saveNotificationLists, {
    showFieldErrors: true,
    ...options,
  });
